module.exports = __webpack_public_path__ + "static/media/expandir-menos.26c696b7.svg";